import React from 'react';
import { Box, Typography } from '@mui/material';
import { formatPhone, googleMapsUrl, hasDistance } from './storeLocations';

/**
 * A store pin's popup on a group's store map: the address, phone and distance, opening Google Maps on click.
 *
 * The `!important` margins override Leaflet's own popup paragraph margins.
 *
 * @param {object} location - one of group.locations, with `distance` once the member's position is known
 */
const StorePopup = ({ location }) => {
  const address = location.address || {};
  return (
    <Box
      sx={{
        minWidth: 200,
        m: '0 !important',
        p: '0 !important',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
      }}
      onClick={() => window.open(googleMapsUrl(location), '_blank')}
    >
      <Typography variant="subtitle2" fontWeight="bold" sx={{ m: '0 !important' }}>
        {location.friendly_name || location.name}
      </Typography>
      <Typography variant="body2" sx={{ m: '0 !important' }}>
        {address.address1}
      </Typography>
      {address.address2 && (
        <Typography variant="body2" sx={{ m: '0 !important' }}>
          {address.address2}
        </Typography>
      )}
      <Typography variant="body2" sx={{ m: '0 !important' }}>
        {address.city}, {address.state} {address.zip_code}
      </Typography>
      {location.phone && (
        <Typography variant="body2" sx={{ m: '0 !important', mt: '4px !important' }}>
          📞 {formatPhone(location.phone)}
        </Typography>
      )}
      {hasDistance(location) && (
        <Typography variant="caption" color="text.secondary" sx={{ m: '0 !important', mt: '4px !important', display: 'block' }}>
          {location.distance.toFixed(1)} miles away
        </Typography>
      )}
      <Typography variant="caption" sx={{ m: '0 !important', mt: '8px !important', display: 'block', color: 'primary.main' }}>
        Click to open in Google Maps
      </Typography>
    </Box>
  );
};

export default StorePopup;
